import * as React from "react";
import { DefaultReduxState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { delUser } from "../../store/actions";
import "./userData.css";
import { useNavigate } from "react-router-dom";

export default function BasicMenu() {
  const dispatch = useDispatch();
  const user = useSelector((state: DefaultReduxState) => state.auth);
  const navigate = useNavigate();

  const handelLogout = () => {
    dispatch(delUser());
    localStorage.removeItem("refToken");
  };

  return (
    <div className="dropdown">
      <button
        className="btn user-btn dropdown-toggle "
        type="button"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span className="btn-text">{user.name}</span>
        <span className="btn-role">
          {user.isCoach ? "Coach" : user.isSuper ? "Super Admin" : "Admin"}
        </span>
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <li>
          <button
            className="dropdown-item"
            onClick={() => navigate("/profile")} // Navigate to profile page
          >
            Profile
          </button>
        </li>

        {user.isSuper && (
          <li>
            <button
              className="dropdown-item"
              onClick={() => navigate("/manage-admins")} // Adjust this route as needed
            >
              Manage Admins
            </button>
          </li>
        )}

        <li>
          <button className="dropdown-item" onClick={() => handelLogout()}>
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
}
